var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2572 2.85829C10.2572 3.40388 10.4739 3.92712 10.8597 4.31291C11.2455 4.6987 11.7688 4.91543 12.3143 4.91543C12.8599 4.91543 13.3832 4.6987 13.769 4.31291C14.1548 3.92712 14.3715 3.40388 14.3715 2.85829C14.3715 2.3127 14.1548 1.78946 13.769 1.40367C13.3832 1.01788 12.8599 0.801147 12.3143 0.801147C11.7688 0.801147 11.2455 1.01788 10.8597 1.40367C10.4739 1.78946 10.2572 2.3127 10.2572 2.85829Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4001 10.0586V9.03C15.4001 7.32577 14.0186 5.94421 12.3144 5.94421C11.1522 5.94421 10.1401 6.58663 9.61386 7.53569",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02866 2.85829C2.02866 3.12844 2.08187 3.39594 2.18525 3.64553C2.28863 3.89511 2.44016 4.12189 2.63118 4.31291C2.8222 4.50393 3.04898 4.65546 3.29856 4.75884C3.54815 4.86222 3.81565 4.91543 4.0858 4.91543C4.35595 4.91543 4.62345 4.86222 4.87303 4.75884C5.12262 4.65546 5.3494 4.50393 5.54042 4.31291C5.73144 4.12189 5.88297 3.89511 5.98635 3.64553C6.08973 3.39594 6.14294 3.12844 6.14294 2.85829C6.14294 2.3127 5.92621 1.78946 5.54042 1.40367C5.15463 1.01788 4.63139 0.801147 4.0858 0.801147C3.54021 0.801147 3.01697 1.01788 2.63118 1.40367C2.24539 1.78946 2.02866 2.3127 2.02866 2.85829Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0586V9.03C1 7.32577 2.38155 5.94421 4.08578 5.94421C5.2479 5.94421 6.25996 6.58663 6.78625 7.53569",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14404 9.02736C6.14404 9.57295 6.36078 10.0962 6.74657 10.482C7.13236 10.8678 7.6556 11.0845 8.20119 11.0845C8.74677 11.0845 9.27002 10.8678 9.65581 10.482C10.0416 10.0962 10.2583 9.57295 10.2583 9.02736C10.2583 8.48177 10.0416 7.95853 9.65581 7.57274C9.27002 7.18695 8.74677 6.97021 8.20119 6.97021C7.6556 6.97021 7.13236 7.18695 6.74657 7.57274C6.36078 7.95853 6.14404 8.48177 6.14404 9.02736Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2872 15.1986C11.2872 13.4944 9.90563 12.1129 8.2014 12.1129C6.49717 12.1129 5.11563 13.4944 5.11563 15.1986",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersActive);
export default __webpack_public_path__ + "static/media/customers-active.9ff7b428a7f1393385fc69c46f0d86be.svg";
export { ForwardRef as ReactComponent };